import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// import actions
import { resetPopupVideoId } from 'js/store/videos/Videos.actions';

// import selectors
import { getPopupVideoId, getVideoById } from 'js/store/videos/Videos.selectors';
import { getYoutubePlaylistById } from 'js/store/youtube/Youtube.selectors';

// import components
import MediaVideo from 'js/components/media/Media.video';

const ModalVideoPopup = () => {
  const dispatch = useDispatch();

  const popupVideoId = useSelector((state) => {
    return getPopupVideoId(state);
  });

  const videoData = useSelector((state) => getVideoById(state, popupVideoId));
  const youtubeData = useSelector((state) => getYoutubePlaylistById(state, popupVideoId));

  useEffect(() => {
    console.log('popupVideoId', popupVideoId);
    document.body.style.overflow = popupVideoId ? 'hidden' : 'auto';
  }, [popupVideoId]);

  return (
    <div className={'modal--video-popup' + (popupVideoId ? ' modal--video-popup--active' : '')}>
      <div className="modal--video-popup__container">
        <button className="modal--video-popup__close" onClick={() => dispatch(resetPopupVideoId())}>
          X
        </button>
        {popupVideoId && popupVideoId?.includes('youtube') ? (
          <div
            className="watch--youtube-video-embed"
            dangerouslySetInnerHTML={{ __html: youtubeData?.embedPlayer || '' }}
          />
        ) : (
          <MediaVideo item={videoData} />
        )}
      </div>
    </div>
  );
};

export default ModalVideoPopup;
